import { Redirect, Route } from "react-router-dom";
// https://medium.com/@tomlarge/private-routes-with-react-router-dom-28e9f40c7146
const PrivateRoute = ({ component: Component, ...rest }) => {
	return (
		<Route
			{...rest}
			render={(props) =>
				localStorage.getItem("authToken") ? (
					<Component {...props} />
				) : (
					<Redirect to="/login" />
				)
			}
		/>
	);
};

export default PrivateRoute;
